import { Menu, Transition } from '@headlessui/react';
import { useAuth } from '../../hooks/useAuth';
import SignoutButton from '../buttons/SignoutButton';

export default function DropdownProfile({
  align,
}: {
  align?: 'left' | 'right';
}): JSX.Element {
  const { user } = useAuth();

  return (
    <Menu as="div" className="relative inline-flex" data-cy="menu-dropdown">
      <Menu.Button className="inline-flex justify-center items-center group">
        <div className="flex items-center truncate">
          <span className="truncate ml-2 text-sm font-medium dark:text-slate-300 group-hover:text-slate-800 dark:group-hover:text-slate-200">
            {user?.attributes.email}
          </span>
          <svg
            className="w-3 h-3 shrink-0 ml-1 fill-current text-slate-400"
            viewBox="0 0 12 12"
          >
            <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
          </svg>
        </div>
      </Menu.Button>
      <Transition
        className={`origin-top-right z-10 absolute top-full min-w-[11rem] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 py-1.5 rounded shadow-lg mt-1 ${
          align === 'right' ? 'right-0' : 'left-0'
        }`}
        enter="transition ease-out duration-200 transform"
        enterFrom="opacity-0 -translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-out duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <Menu.Items as="ul" className="focus:outline-none">
          <Menu.Item as="li">
            {({ active }) => (
              <a
                className={`font-medium text-sm flex items-center py-1 px-3 ${
                  active
                    ? 'text-indigo-600 dark:text-indigo-400'
                    : 'text-indigo-500'
                }`}
                href="/settings/account"
              >
                Settings
              </a>
            )}
          </Menu.Item>
          <Menu.Item as="li">
            <SignoutButton />
          </Menu.Item>
        </Menu.Items>
        <div className="text-sm text-slate-600 dark:text-slate-300 px-3 py-2 relative group">
          <span>For support, email: <br />support@hellometer.io</span>
          <div className="absolute top-full left-0 transform -translate-x-1/2 mb-2 hidden group-hover:block bg-slate-800 dark:bg-slate-900 text-white dark:text-slate-200 text-xs rounded px-2 py-1 w-[28rem] text-center shadow-md z-20">
            please use this email to reach out to us with any questions, concerns, suggestions, or even just to say hello!
          </div>
        </div>
      </Transition>
    </Menu>
  );
}
